import React, { useState } from 'react';
import { Waves } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const VolTool = () => {
    const [bs, setBs] = useState(4);
    const [rv, setRv] = useState(100);
    const [cv, setCv] = useState(150);

    const res = bs * (rv / (cv || 1));

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Volatility Position Sizing</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Base Size (Lots)" value={bs} onChange={setBs} />
                <InputGroup label="Ref Vol" value={rv} onChange={setRv} />
                <InputGroup label="Current Vol" value={cv} onChange={setCv} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-amber">
                    <div className="tct-data-row"><span className="tct-label">Adjusted Size</span><span className="tct-value big-value val-amber">{res.toFixed(2)} lots</span></div>
                </div>
            </div>
            <InfoBox
                title="Volatility Based Position Sizing Explained"
                meta="Learn how traders adjust position sizes based on market volatility"
                sections={[
                { title: "Introduction", content: "Markets become more volatile during major events.<br><br>Volatility based position sizing adjusts trade size accordingly." },
                { title: "Example", content: "If volatility doubles, position size should reduce.<br><br>This prevents excessive losses during unstable markets." }
                ]}
            />
        </div>
    );
};

export default VolTool;
